import { ResourceTypes, Solutions } from '@app/src/wf-constants'
import type { ProviderType } from '@app/src/wf-constants'

// Return values are i18n key fragments, not display text: 'investee' renders as "Portfolio company".
export const getProviderTypeFromSolution = (solutionType?: string): ProviderType => {
  switch (solutionType?.toLowerCase()) {
    case Solutions.Sourcing:
    case Solutions.Transparency:
    case Solutions.SourcingStart:
      return ResourceTypes.Supplier
    case Solutions.Investment:
      return ResourceTypes.Investee
    case Solutions.Finance:
    default:
      return ResourceTypes.Company
  }
}
